import {
  IDataPreference,
  IFiltrosVendasCanceladas
} from "@/features/financas/views/Indicadores/@types/type";
import { AbstractSaveToApi } from "../types";
import VendasCanceladasStrategy from "../strategyPorCard/VendasCanceladasStrategy";

export default class SaveVendasCanceladasToApi extends AbstractSaveToApi<IFiltrosVendasCanceladas> {
  buildPreference(
    filtro: IFiltrosVendasCanceladas
  ): IDataPreference<unknown>[] {
    const preferencia = new VendasCanceladasStrategy();
    const preferences: IDataPreference<unknown>[] = [];

    if (filtro.data && filtro.data.length > 0) {
      preferences.push(
        preferencia.createRangeInicio(filtro.data as string),
        preferencia.createRangeFim(filtro.data as string)
      );
    }

    return [...preferences];
  }
}
